/* ai-tabs-header.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./ai-tabs-header.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/core/chevron-up';
import { Inline } from '@atlaskit/primitives/compiled';
import { Tab, TabList } from '@atlaskit/tabs';
import { SourcesStack } from '../../../common/ui/sources-stack/sources-stack';
import { messages } from './messages';
var styles = {
  fullHeight: "_4t3i1osq",
  tabListAndButtonInline: "_19bvpxbi _u5f3pxbi _ca0q12x7 _1nw51j28"
};
export var AITabsHeader = function AITabsHeader(_ref) {
  var collapsed = _ref.collapsed,
    onExpandCollapseButtonClick = _ref.onExpandCollapseButtonClick,
    showSourcesTab = _ref.showSourcesTab;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    spread: "space-between",
    testId: "ai-tabs-header",
    xcss: styles.tabListAndButtonInline
  }, /*#__PURE__*/React.createElement(TabList, null, /*#__PURE__*/React.createElement(Tab, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.ai_answer_card_tab_ai_answer)), showSourcesTab ? /*#__PURE__*/React.createElement(Tab, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.ai_answer_card_tab_sources)) : null), typeof collapsed === 'boolean' ? /*#__PURE__*/React.createElement(IconButton, {
    appearance: "subtle",
    icon: collapsed ? ChevronDownIcon : ChevronUpIcon,
    label: formatMessage(collapsed ? messages.ai_answer_card_expand_button : messages.ai_answer_card_collapse_button),
    spacing: "compact",
    onClick: onExpandCollapseButtonClick
  }) : null);
};
export var AITabsHeaderWithSourcesStack = function AITabsHeaderWithSourcesStack(_ref2) {
  var collapsed = _ref2.collapsed,
    onExpandCollapseButtonClick = _ref2.onExpandCollapseButtonClick,
    sources = _ref2.sources;
  var _useIntl2 = useIntl(),
    formatMessage = _useIntl2.formatMessage;
  return /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    spread: "space-between",
    testId: "ai-tabs-header-with-sources-stack",
    xcss: styles.tabListAndButtonInline
  }, /*#__PURE__*/React.createElement(TabList, null, /*#__PURE__*/React.createElement(Tab, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.ai_answer_card_tab_ai_answer)), sources && sources.length > 0 ? /*#__PURE__*/React.createElement(Tab, null, /*#__PURE__*/React.createElement(Inline, {
    space: "space.050",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SourcesStack, {
    sources: sources
  }), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.ai_answer_card_tab_sources_with_pluralization, {
    values: {
      sourcesCount: sources.length
    }
  }))))) : null), typeof collapsed === 'boolean' ? /*#__PURE__*/React.createElement(IconButton, {
    appearance: "subtle",
    icon: collapsed ? ChevronDownIcon : ChevronUpIcon,
    label: formatMessage(collapsed ? messages.ai_answer_card_expand_button : messages.ai_answer_card_collapse_button),
    spacing: "compact",
    onClick: onExpandCollapseButtonClick
  }) : null);
};